import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { StatusPill } from '../ui';
import { Alert, Modal } from '../ItAssets/common';

export { Alert, Modal };

export const Ctx = createContext(null);
export const useKpc = () => useContext(Ctx);

export function useList(load, deps) {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [tick, setTick] = useState(0);
  useEffect(() => {
    let on = true;
    setError('');
    load().then((d) => { if (on) setData(d); }).catch((e) => { if (on) setError(e.message); });
    return () => { on = false; };
  }, [...deps, tick]); // eslint-disable-line react-hooks/exhaustive-deps
  const reload = useCallback(() => setTick((t) => t + 1), []);
  return { data, error, reload };
}

export const when = (iso) => (iso ? new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'America/New_York' }) : '');
export const duration = (a, b) => { if (!a || !b) return ''; const s = Math.round((new Date(b) - new Date(a)) / 1000); return s >= 60 ? `${Math.floor(s / 60)} min ${s % 60} s` : `${s} s`; };

// Leading and trailing spaces made visible: Klaviyo values carry them and the rules match them exactly.
export function ws(value) {
  const v = value == null ? '' : String(value);
  const lead = v.length - v.trimStart().length, trail = v.length - v.trimEnd().length;
  if (!lead && !trail) return <span className="uh-mono">{v}</span>;
  return <span className="uh-mono">{lead > 0 && <span className="uh-kpc-ws">{'␣'.repeat(lead)}</span>}{v.trim()}{trail > 0 && <span className="uh-kpc-ws">{'␣'.repeat(trail)}</span>}</span>;
}

// The Hub's red pill tone is `can`; callers may say `bad`.
export const Pill = ({ tone, children }) => <StatusPill tone={tone === 'bad' ? 'can' : tone}>{children}</StatusPill>;

export function Confirm({ title, text, yes = 'Confirm', danger, onYes, onNo, busy, error }) {
  return (
    <Modal title={title} onClose={onNo} footer={<><button type="button" className="uh-btn" onClick={onNo}>Cancel</button>
      <button type="button" className={`uh-btn ${danger ? 'danger' : 'primary'}`} disabled={busy} onClick={onYes}>{yes}</button></>}>
      {error && <Alert>{error}</Alert>}
      <p>{text}</p>
    </Modal>
  );
}
